module.exports = __webpack_public_path__ + "static/img/isp_img_2.24679ab.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_svg/isp_img_2.svg
// module id = fdtU
// module chunks = 0